import { en } from './assets/lg/en';
import { fr } from './assets/lg/fr';
import { ar } from './assets/lg/ar';

const ENVIRONMENT = {
  developpement: {
    API_URL: 'http://127.0.0.1:8000/api',
    BACKEND_URL: 'http://127.0.0.1:8000',
  },
  production: {
    API_URL: 'https://fmpmsimulationcenter.com/backend/api',
    BACKEND_URL: 'https://fmpmsimulationcenter.com/backend',
  },
};

const PLATFORM = 'production';

export function getLang(lang) {
  if (lang === 'en') {
    return en;
  } else if (lang === 'ar') {
    return ar;
  } else {
    return fr;
  }
}

export default function getEnvironement() {
  return ENVIRONMENT[PLATFORM];
}
